import {
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  useDisclosure,
  Flex,
  Alert,
} from "@chakra-ui/react";
import { getLayout } from "components/Layout/BrandSettings";
import HeadTitle from "components/Shared/HeadTitle";
import CreateButton from "components/Shared/CreateButton";
import BrandUsersTable from "components/Core/AccountInfo/Users/Table";
import InviteModalContent from "components/Core/AccountInfo/Users/InviteModalContent";
import ParentBrandAlert from "components/Shared/ParentBrandAlert";
import { useCurrentBrandData } from "utils/currentUserHooks";
import BrandName from "components/Shared/BrandName";

export default function BrandSettingsIndex() {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const brand = useCurrentBrandData();
  return (
    <>
      <HeadTitle title="Users" />
      <Flex alignItems="flex-end" marginBottom=".75em">
        <Heading as="h1" variant="section-header">
          Users
        </Heading>
        <CreateButton onClick={onOpen} isDisabled={isOpen} ml="auto">
          Invite User
        </CreateButton>
      </Flex>

      <ParentBrandAlert my={5} fontSize="sm" />

      {brand?.isParent && (
        <Alert display="block" lineHeight="normal" my={5} fontSize="sm">
          <b>
            <BrandName />
          </b>{" "}
          is a parent brand. All users of this brand will have access to all of
          this brand’s sub-brands.
        </Alert>
      )}

      <BrandUsersTable />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <InviteModalContent {...{ onClose }} />
        </ModalContent>
      </Modal>
    </>
  );
}

BrandSettingsIndex.getLayout = getLayout;
